import { useFirebaseUser } from '@/hooks/useFirebaseUser'
import { useUsersServiceGetMe } from '../client/queries'
import * as queryKeys from '../query-keys'

export const useMe = () => {
  const { decodedJwt, firebaseUser, isLoggedIn } = useFirebaseUser()
  const userQuery = useUsersServiceGetMe(queryKeys.getMe(firebaseUser?.uid ?? ''), {
    enabled: !!firebaseUser,
  })

  const isProvider = !!(decodedJwt?.claims?.roles as string[])?.includes('provider')

  return {
    firebaseUser,
    isLoggedIn,
    isProvider,
    isVerified: !!firebaseUser?.emailVerified,
    user: userQuery.data,
    userQuery,
  }
}
